import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import modalsContainerSelector from '../../selectors/modal/ModalsContainerSelector';
import OneWayConfirmationModal from './OneWayConfirmationModal';
import OneWayNavigationOfflineModal from './OneWayNavigationOfflineModal';

const ModalsContainer = (props) => {
    const { shouldRenderOneWayNavigationModals } = props;

    return (<React.Fragment>
        { shouldRenderOneWayNavigationModals &&
            <React.Fragment>
                <OneWayConfirmationModal />
                <OneWayNavigationOfflineModal />
            </React.Fragment>
        }
    </React.Fragment>);
};

ModalsContainer.propTypes = {
    shouldRenderOneWayNavigationModals: PropTypes.bool.isRequired,
};

const mapStateToProps = state => modalsContainerSelector.selectProps(state);
export default connect(mapStateToProps)(ModalsContainer);
